import React from 'react';
import i18next from 'i18next';
import { useHistory } from 'react-router-dom';
import reactGA from 'react-ga';
import { Box, Typography, Button } from '@mui/material';
import images from '../../../assets/img';
import styles from './landing-page-banner.module.scss';

const LandingPageBanner = () => {
  const history = useHistory();

  const handleExploreMoreClick = () => {
    history.push('/listing?asset-type=solutions');
    reactGA.event({
      category: 'Explore More',
      action: 'User Clicked on Explore More',
      label: 'Explore More'
    });
  };

  return (
    <Box className={styles['banner-container']}>
      <Box
        component='img'
        src={images.landingPageBanner}
        className={styles['banner']}
        alt={i18next.t('SOLUTIONS.EXPLORE_SOLUTIONS')}
      />
      <Box className={styles['card']} sx={{ backgroundColor: 'common.light' }}>
        <Typography component='p' variant='h5' mb={2} className={styles['heading']}>
          {i18next.t('HOME_PAGE.REVAMPED_HOMEPAGE_BANNER.ONE_STOP_PLATFORM')}
        </Typography>
        <Box>
          <Button
            variant='filledBtn'
            className={styles['button']}
            disableElevation
            onClick={handleExploreMoreClick}
          >
            {i18next.t('HOME_PAGE.REVAMPED_HOMEPAGE_BANNER.EXPLORE_MORE')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default LandingPageBanner;
